import Modal from "components/Modal";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useModal from "hooks/useModal";
import { useDispatch, useSelector } from "react-redux";
import { KeyboardTimePicker } from "@material-ui/pickers";
import ForwardIcon from "@material-ui/icons/Forward";
import CastShiftRes from "../../../types/res/castShift/CastShiftRes";
import { updateCastShift } from "../../../redux/actions/castShift";
import UpdateCastShiftReq from "../../../types/req/castShift/UpdateCastShiftReq";
import ShiftStatus from "../../../types/enum/ShiftStatus";
type Props = {
  setStateShifts: any;
  shifts: CastShiftRes[];
};
const CastScheduleOnShiftMove: React.FC<Props> = ({
  setStateShifts,
  shifts,
}) => {
  const { t } = useTranslation("castSchedule");
  const [castScheduleOnShiftMoveModal, setCastScheduleOnShiftMoveShow] =
    useModal("castScheduleOnShiftMove");
  const companyId = useSelector((state) => state.account.staff.companyId);
  const [loading, setLoading] = useState(false);
  const [changeShift, setChangeShift] = useState<CastShiftRes>();
  const [oldShift, setOldShift] = useState<CastShiftRes>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!castScheduleOnShiftMoveModal?.meta?.castShift) return;
    setChangeShift(castScheduleOnShiftMoveModal?.meta?.castShift);
    const shift = shifts.find(
      (shift) =>
        shift.castShiftId ===
        castScheduleOnShiftMoveModal?.meta?.castShift?.castShiftId
    );
    setOldShift(shift);
  }, [castScheduleOnShiftMoveModal?.meta]);

  useEffect(() => {
    if (castScheduleOnShiftMoveModal.show) return;
    setStateShifts(shifts);
  }, [castScheduleOnShiftMoveModal?.show]);
  const onClickSubmit = async () => {
    if (!changeShift) return;
    await dispatch(
      updateCastShift(
        companyId,
        new UpdateCastShiftReq({
          ...changeShift,
          shops: changeShift.shops.map((shop) => shop.shopId),
        })
      )
    );
    setCastScheduleOnShiftMoveShow(false);
  };
  return (
    <Modal
      show={castScheduleOnShiftMoveModal.show}
      setShow={setCastScheduleOnShiftMoveShow}
      title={t("orderTitle.shift", {
        name: castScheduleOnShiftMoveModal.meta?.castShift?.cast?.displayName,
      })}
    >
      <Container>
        <Box display="flex" justifyContent="center">
          <Box display="flex" flexDirection="column">
            <Typography variant="body1">{t("sections.beforeChange")}</Typography>
            <KeyboardTimePicker
              label={t("orderForm.planWorkStart")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={oldShift?.planWorkStart || null}
              format="YYYY/MM/DD HH:mm"
              onChange={() => ""}
              minutesStep={5}
              variant="inline"
              disabled={true}
              style={{ marginTop: "10px" }}
            />
            <KeyboardTimePicker
              label={t("orderForm.planWorkEnd")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={oldShift?.planWorkEnd || null}
              format="YYYY/MM/DD HH:mm"
              onChange={() => ""}
              minutesStep={5}
              variant="inline"
              disabled={true}
              style={{ marginTop: "10px" }}
            />

            <KeyboardTimePicker
              label={t("orderForm.actualWorkStart")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={oldShift?.actualWorkStart || null}
              format="YYYY/MM/DD HH:mm"
              onChange={() => ""}
              minutesStep={5}
              variant="inline"
              disabled={true}
              style={{ marginTop: "10px" }}
            />
            <KeyboardTimePicker
              label={t("orderForm.actualWorkEnd")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={oldShift?.actualWorkEnd || null}
              format="YYYY/MM/DD HH:mm"
              onChange={() => ""}
              minutesStep={5}
              variant="inline"
              disabled={true}
              style={{ marginTop: "10px" }}
            />

            <KeyboardTimePicker
              label={t("orderForm.workOffStart")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={oldShift?.workOffStart || null}
              format="YYYY/MM/DD HH:mm"
              onChange={() => ""}
              minutesStep={5}
              variant="inline"
              disabled={true}
              style={{ marginTop: "10px" }}
            />
            <KeyboardTimePicker
              label={t("orderForm.workOffEnd")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={oldShift?.workOffEnd || null}
              format="YYYY/MM/DD HH:mm"
              onChange={() => ""}
              minutesStep={5}
              variant="inline"
              disabled={true}
              style={{ marginTop: "10px" }}
            />
            <TextField
              label={t("orderForm.status")}
              value={oldShift?.status || ""}
              fullWidth
              select
              variant="outlined"
              margin="normal"
              onChange={() => ""}
              disabled
            >
              {Object.entries(ShiftStatus).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label={t("orderForm.castMemo")}
              value={oldShift?.castMemo || ""}
              fullWidth
              variant="outlined"
              margin="normal"
              onChange={() => ""}
              disabled
            />
            <TextField
              label={t("orderForm.staffMemo")}
              value={oldShift?.castMemo || ""}
              fullWidth
              variant="outlined"
              margin="normal"
              onChange={() => ""}
              disabled
            />
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            marginX={3}
          >
            <ForwardIcon />
          </Box>
          <Box display="flex" flexDirection="column">
            <Typography variant="body1">{t("sections.afterChange")}</Typography>
            <KeyboardTimePicker
              label={t("orderForm.planWorkStart")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={changeShift?.planWorkStart || null}
              format="YYYY/MM/DD HH:mm"
              onChange={(date) =>
                setChangeShift((prev: any) => ({
                  ...prev,
                  planWorkStart: date?.toDate(),
                }))
              }
              minutesStep={5}
              variant="inline"
              style={{ marginTop: "10px" }}
            />
            <KeyboardTimePicker
              label={t("orderForm.planWorkEnd")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={changeShift?.planWorkEnd || null}
              format="YYYY/MM/DD HH:mm"
              onChange={(date) =>
                setChangeShift((prev: any) => ({
                  ...prev,
                  planWorkEnd: date?.toDate(),
                }))
              }
              minutesStep={5}
              variant="inline"
              style={{ marginTop: "10px" }}
            />

            <KeyboardTimePicker
              label={t("orderForm.actualWorkStart")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={changeShift?.actualWorkStart || null}
              format="YYYY/MM/DD HH:mm"
              onChange={(date) =>
                setChangeShift((prev: any) => ({
                  ...prev,
                  actualWorkStart: date?.toDate(),
                }))
              }
              minutesStep={5}
              variant="inline"
              style={{ marginTop: "10px" }}
            />
            <KeyboardTimePicker
              label={t("orderForm.actualWorkEnd")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={changeShift?.actualWorkEnd || null}
              format="YYYY/MM/DD HH:mm"
              onChange={(date) =>
                setChangeShift((prev: any) => ({
                  ...prev,
                  actualWorkEnd: date?.toDate(),
                }))
              }
              minutesStep={5}
              variant="inline"
              style={{ marginTop: "10px" }}
            />

            <KeyboardTimePicker
              label={t("orderForm.workOffStart")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={changeShift?.workOffStart || null}
              format="YYYY/MM/DD HH:mm"
              onChange={(date) =>
                setChangeShift((prev: any) => ({
                  ...prev,
                  workOffStart: date?.toDate(),
                }))
              }
              minutesStep={5}
              variant="inline"
              style={{ marginTop: "10px" }}
            />
            <KeyboardTimePicker
              label={t("orderForm.workOffEnd")}
              inputVariant="outlined"
              InputLabelProps={{ shrink: true }}
              value={changeShift?.workOffEnd || null}
              format="YYYY/MM/DD HH:mm"
              onChange={(date) =>
                setChangeShift((prev: any) => ({
                  ...prev,
                  workOffEnd: date?.toDate(),
                }))
              }
              minutesStep={5}
              variant="inline"
              style={{ marginTop: "10px" }}
            />
            <TextField
              label={t("orderForm.status")}
              select
              value={changeShift?.status || ""}
              fullWidth
              variant="outlined"
              margin="normal"
              onChange={(event) => {
                event.persist();
                setChangeShift((prev: any) => ({
                  ...prev,
                  status: event.target.value,
                }));
              }}
            >
              {Object.entries(ShiftStatus).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label={t("orderForm.castMemo")}
              value={changeShift?.castMemo || ""}
              fullWidth
              variant="outlined"
              margin="normal"
              onChange={(event) => {
                event.persist();
                setChangeShift((prev: any) => ({
                  ...prev,
                  castMemo: event.target.value,
                }));
              }}
            />
            <TextField
              label={t("orderForm.staffMemo")}
              value={changeShift?.staffMemo || ""}
              fullWidth
              variant="outlined"
              margin="normal"
              onChange={(event) => {
                event.persist();
                setChangeShift((prev: any) => ({
                  ...prev,
                  staffMemo: event.target.value,
                }));
              }}
            />
          </Box>
        </Box>
        <Box
          display="flex"
          style={{ margin: "10px 0" }}
          justifyContent="space-evenly"
        >
          <Button
            variant="contained"
            color="default"
            disabled={loading}
            onClick={() => setCastScheduleOnShiftMoveShow(false)}
          >
            {loading ? (
              <CircularProgress color="inherit" size={24} />
            ) : (
              t("common.no")
            )}
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={onClickSubmit}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : t("common.yes")}
          </Button>
        </Box>
      </Container>
    </Modal>
  );
};
export default CastScheduleOnShiftMove;
